<template>
  <div>
    <div class="header page-header">
      <div >USERS</div>
      <p>Add new user</p>
    </div>
    <div class="card">
      <div class="form">
        <div class="form__group form__group--spaced">
          <label>First Name</label>
          <input
            placeholder="Type first name"
            class="input input__round input--user"
            style="width: 100%; max-width: 350px"
            v-model="user.first_name"
          >
        </div>
        <div class="form__group form__group--spaced">
          <label>Last Name</label>
          <input
            placeholder="Type last name"
            class="input input__round input--user"
            style="width: 100%; max-width: 350px"
            v-model="user.last_name"
          >
        </div>
        <div class="form__group form__group--spaced">
          <label>E-Mail</label>
          <input
            type="email"
            placeholder="Type user's email"
            class="input input__round input--mail"
            style="width: 100%; max-width: 350px"
            v-model="user.email"
          >
        </div>
        <div class="form__group form__group--spaced">
          <label>Client</label>
          <div>
            <Multiselect
              v-model="company"
              label="name"
              :options="clients"
              placeholder='Select client...'
              :close-on-select="true"
              style="width: 100%; max-width: 298px"
              class="input input__round input--dropdown"
              :multiple="false"
            ></Multiselect>
          </div>
        </div>
      </div>
      <div v-if="error.length>0" class="errors-wrapper">
        Please correct the following error(s):
        <ul v-for="err in error" :key="err">
          <li class="error-item">{{err}}</li>
        </ul>
      </div>
      <div class="form__actions">
        <Button
          text="Save"
          class="btn btn__primary"
          style="margin-left: auto; display: block"
          @on-click="createUser"
          :loading="loading"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Button from "../partials/Button.vue";
import Multiselect from "vue-multiselect";
import Paginate from "vuejs-paginate";
import * as api from "./api.js";

const INITIAL_CLIENT = {
  first_name: "",
  last_name: "",
  email: "",
  company_id: ""
};
export default {
  name: "CreateUser",
  components: {
    Button,
    Paginate,
    Multiselect
  },
  created: async function() {
    this.clients = (await api.fetchClients({})).map(c => {
      return { name: c.name, id: c.id };
    });
    document.title = 'Add User | PayGate Invoice'
  },
  methods: {
    createUser: async function() {
      this.error = [];
      if (this.user.first_name.length < 1) {
        this.error.push("First name is required");
      }
      if (this.user.last_name.length < 1) {
        this.error.push("Last name is required");
      }
      if (this.user.email.length < 1) {
        this.error.push("Email name is required");
      }
      if (
        !/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(
          String(this.user.email).toLowerCase()
        )
      ) {
        this.error.push("Email format is invalid");
      }
      if (!this.company.id) {
        this.error.push("Client field is required");
      }
      if (this.error.length === 0) {
        this.user.company_id = this.company.id;
        let response;
        this.loading = true;
        this.error = "";
        try {
          response = await api.createUser(this.user);
          this.user = INITIAL_CLIENT;
          this.loading = false;
          this.$toasted.success("User added successfully", {
            className: "success-toast"
          });
          this.$router.push("/dashboard/users");
        } catch (e) {
          this.loading = false;
          this.error = "error";
          let err_msg = "Something went wrong";
          Object.keys(e.response.data.errors).map(
            key => (err_msg = e.response.data.errors[key][0])
          );
          this.$toasted.error(err_msg, { className: "error-toast" });
        }
      }
    }
  },
  data() {
    return {
      user: INITIAL_CLIENT,
      error: [],
      loading: false,
      clients: [],
      company: { name: "", id: "" }
    };
  }
};
</script>

<style lang="scss" scoped>
.errors-wrapper {
  margin-left: 30px;
  margin-top: 20px;
  font-family: Montserrat-Regular;
}
.error-item {
  color: red;
  opacity: 0.7;
  font-family: Montserrat-SemiBold;
}
.button-container {
  display: flex;
  justify-content: flex-end;
}
</style>